import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { Role, rolesApi } from 'api/roles'
import Spinner from 'components/Spinner'
import { TooltipWhenDisabled } from 'components/TooltipWhenDisabled'
import { isAssignableRole, isTemplateRole } from 'constants/roles'
import { useIsRbacAdmin } from 'hooks/useIsRbacAdmin'
import { buildTranslate } from 'locales'
import { useState } from 'react'
import { CreateRoleModal } from './CreateRoleModal'
import { DeleteRoleModal } from './DeleteRoleModal'
import { RoleSection } from './RoleSection'

const t = buildTranslate('dashboard_access.roles_tab')

export const RolesTab = () => {
  const { data, isLoading } = rolesApi.useGetRolesQuery()
  const isAdmin = useIsRbacAdmin()
  const [createModalVisible, setCreateModalVisible] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [selectedRole, setSelectedRole] = useState<Role>()

  const roles = data?.roles ?? []
  const assignableRoles = roles.filter(isAssignableRole)
  const templateRoles = roles.filter(isTemplateRole)

  const handleDelete = (role: Role) => {
    setSelectedRole(role)
    setDeleteModalVisible(true)
  }

  return (
    <Spinner isLoading={isLoading}>
      <div className="d-flex justify-content-between align-items-center mb-l">
        <Text.Header2 className="m-0">{t('title')}</Text.Header2>
        <TooltipWhenDisabled disabled={!isAdmin} tooltip={t('requires_admin')}>
          <Button
            kind="primary"
            disabled={!isAdmin}
            onClick={() => setCreateModalVisible(true)}
          >
            {t('create_new_role')}
          </Button>
        </TooltipWhenDisabled>
      </div>
      <RoleSection
        title={t('assignable_roles')}
        roles={assignableRoles}
        canManage={isAdmin}
        onDelete={handleDelete}
      />
      <RoleSection
        title={t('role_templates')}
        tooltip={t('role_templates_subtitle')}
        roles={templateRoles}
        badgeVariant="template"
        canManage={isAdmin}
        onDelete={handleDelete}
      />

      <CreateRoleModal
        visible={createModalVisible}
        setIsVisible={setCreateModalVisible}
        roles={roles}
      />
      <DeleteRoleModal
        visible={deleteModalVisible}
        setIsVisible={setDeleteModalVisible}
        role={selectedRole}
      />
    </Spinner>
  )
}
